export default {
  manage_cameraManagement_editPairing_title: "Emparejamiento de Camara",
  manage_cameraManagement_editPairing_select: "Seleccion una unidad para empajera con la Camara",
  manage_cameraManagement_editPairing_confirmText:
    "¿Esta seguro de Agregar/Quitar el emparejamiento de Camara?",
  manage_cameraManagement_editPairing_confirmTitle: "Agregar/Quitar emparejamiento de Camera",
  manage_cameraManagement_editPairing_pairingSuccessSave: "La cámara se ha emparejado exitosamente",
  manage_cameraManagement_editPairing_unPairingSuccessSave:
    "La cámara se ha desemparejado exitosamente",

  manage_cameraManagement_editPairing_changeConfirmMessage:
    "La cámara ya tiene una unidad emparejada. Está seguro de que desea cambiar el emparejamiento?",
  manage_cameraManagement_editPairing_pairingConfirmMessage: "¿Está seguro de emparejar la cámara?",
  manage_cameraManagement_editPairing_unpairingConfirmMessage:
    "¿Está seguro de desemparejar la cámara?",

  manage_cameraManagement_editPairing_changeConfirmTitle: "Agregar/Quitar emparejamiento de Camera",
  manage_cameraManagement_editPairing_pairingConfirmTitle: "Agregar emparejamiento de Camera",
  manage_cameraManagement_editPairing_unpairingConfirmTitle: "Quitar emparejamiento de Camera",
  manage_cameraManagement_editPairing_warningMessageFirst:
    "Esta unidad está actualmente emparejada con",
  manage_cameraManagement_editPairing_warningMessageSecond:
    "Si continúa esta unidad será eliminada de",
  manage_cameraManagement_editPairing_warningMessageThird: "y asignada a"
};
